import { render, staticRenderFns } from "./SchoolList.vue?vue&type=template&id=d65040fe&scoped=true&"
import script from "./SchoolList.vue?vue&type=script&lang=ts&"
export * from "./SchoolList.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolList.vue?vue&type=style&index=0&id=d65040fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65040fe",
  null
  
)

export default component.exports